@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.group {
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: var(--space-3);
  font-size: 14px;
  color: $color-accent1-800;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.chip {
  padding: 9px 16px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: 12px;
  cursor: pointer;
  transition:
    background 0.12s ease,
    color 0.12s ease,
    border-color 0.12s ease;

  &:hover {
    border-color: var(--border-strong);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.active {
  color: var(--text-inverse);
  background: $color-brand-700;
  border-color: $color-brand-700;

  &:hover {
    border-color: $color-brand-700;
  }
}

.calendar {
  margin-top: var(--space-4);
}
